import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { message } from 'antd'
import NavDropdown from '@/components/layout/NavDropdown'
import LanguageSwitcher from '@/components/layout/LanguageSwitcher'
import useResponsive from '@/hooks/useResponsive'
import cosmosLogo from '@/assets/images/cosmos-logo.svg'
import './index.less'

const CONTACT_EMAIL = 'Shaun.he@cosmos.ag'

const Header = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { isMobileOrTablet } = useResponsive()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [solutionsExpanded, setSolutionsExpanded] = useState(false)

  const solutionsItems = [
    {
      label: t('solutions.smartLaborPerformance'),
      path: '/solutions/smart-labor-performance',
    },
    {
      label: t('solutions.yieldIntelligence'),
      path: '/solutions/yield-intelligence',
    },
    {
      label: t('solutions.harvestManagement'),
      path: '/solutions/harvest-management',
    },
  ]

  const handleContact = () => {
    window.location.href = `mailto:${CONTACT_EMAIL}`
  }

  const handleLogin = () => {
    message.info(t('comingSoon.title'))
  }

  const closeDrawer = () => setDrawerOpen(false)

  const handleMobileNav = (path: string) => {
    navigate(path)
    closeDrawer()
  }

  return (
    <>
      {!isMobileOrTablet && (
        <div className="header__topbar">
          <div className="header__topbar-inner">
            <button className="header__topbar-login" onClick={handleLogin}>
              {t('nav.login')}
            </button>
            <LanguageSwitcher compact />
          </div>
        </div>
      )}

      <header className="header">
        <div className="header__inner">
          <Link to="/" className="header__logo">
            <img src={cosmosLogo} alt="COSMOS" />
          </Link>

          {!isMobileOrTablet && (
            <>
              <nav className="header__nav">
                <button
                  className="header__nav-link"
                  onClick={() => navigate('/')}
                >
                  {t('nav.customerSuccess')}
                </button>
                <NavDropdown
                  label={t('nav.solutions')}
                  items={solutionsItems}
                  menuTheme="gray"
                />
                <button
                  className="header__nav-link"
                  onClick={() => navigate('/partners')}
                >
                  {t('nav.partnerEcosystem')}
                </button>
              </nav>

              <div className="header__actions">
                <button className="header__contact" onClick={handleContact}>
                  {t('nav.contactUs')}
                </button>
              </div>
            </>
          )}

          {isMobileOrTablet && (
            <button
              className="header__hamburger"
              onClick={() => setDrawerOpen(true)}
              aria-label="Open menu"
            >
              ☰
            </button>
          )}
        </div>
      </header>

      {isMobileOrTablet && drawerOpen && (
        <>
          <div className="mobile-drawer__overlay" onClick={closeDrawer} />
          <div className="mobile-drawer mobile-drawer--open">
            <button
              className="mobile-drawer__close"
              onClick={closeDrawer}
              aria-label="Close menu"
            >
              ✕
            </button>
            <nav className="mobile-drawer__nav">
              <button
                className="mobile-drawer__link"
                onClick={() => handleMobileNav('/')}
              >
                {t('nav.customerSuccess')}
              </button>

              <button
                className="mobile-drawer__group-title"
                onClick={() => setSolutionsExpanded(prev => !prev)}
              >
                {t('nav.solutions')}
                <span>{solutionsExpanded ? '▴' : '▾'}</span>
              </button>
              {solutionsExpanded && (
                <div className="mobile-drawer__group-items">
                  {solutionsItems.map(item => (
                    <button
                      key={item.path}
                      className="mobile-drawer__sub-link"
                      onClick={() => handleMobileNav(item.path)}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
              )}

              <button
                className="mobile-drawer__link"
                onClick={() => handleMobileNav('/partners')}
              >
                {t('nav.partnerEcosystem')}
              </button>
            </nav>

            <div className="mobile-drawer__actions">
              <LanguageSwitcher />
              <button className="header__login" onClick={handleLogin}>
                {t('nav.login')}
              </button>
              <button className="header__contact" onClick={handleContact}>
                {t('nav.contactUs')}
              </button>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default Header
